import moment from "moment";

export function isChildOf(child, parent) {
    var node = child.parentNode;
    while (node != null) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

export function parseDate(date) {
    if (date != null && date !== '' && date.split("-")[0].substring(0,4).length === 4) {
        date = moment(date).format('DD-MM-YYYY');
    }

    return date;
}

export function parseTime(time) {
    return time.substr(0, 5);
}

export function calculatePlanningAppointmentEndTime(time, durationHours) {
    const startTime = moment(time, "HH:mm:ss");
    let [hours, minutes] = durationHours.split(".");
    const endTime = moment(startTime).add(hours, 'hours');
    if(minutes != null) {
        endTime.add((minutes / 100 * 60), 'minutes');
    }
    return startTime.utc(true).format("HH:mm") + " - " + endTime.utc(true).format("HH:mm");
}
